export const CategoriesActionTypes = {
  GET_CATEGORIES: "GET_CATEGORIES",
  RESET_CATEGORIES: "RESET_CATEGORIES",
  SELECT_CATEGORY: "SELECT_CATEGORY",
};
